module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseInput', {
    attrs: {
      "error": _vm.error,
      "required": _vm.required
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('template', {
    slot: "input"
  }, [(!_vm.tempImage) ? [_c('ClientColorButton', {
    attrs: {
      "size": 's'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.chooseImage($event)
      }
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('input', {
    ref: "imageInput",
    attrs: {
      "type": "file",
      "accept": _vm.acceptValues
    },
    on: {
      "change": _vm.loadImage
    }
  })] : [_c('div', {
    staticClass: "preview",
    on: {
      "click": function($event) {
        _vm.togglePreview(true);
      }
    }
  }, [(_vm.tempImage) ? _c('img', {
    attrs: {
      "src": _vm.tempImage
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "remove-button",
    attrs: {
      "title": _vm.$trad.common.remove
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeImage($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/effacer.png"),
      "alt": ""
    }
  })])], _vm._v(" "), (_vm.tempImage && _vm.previewBool) ? _c('ImgPreview', {
    attrs: {
      "img": _vm.tempImage
    },
    on: {
      "close": function($event) {
        _vm.togglePreview(false);
      }
    }
  }) : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ba3cae0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/ImageUploadBloc.vue
// module id = 3306
// module chunks = 0